import { getFeathersClient } from '@/pages/chat/feathers-client'
import { useChatStore } from './chat-store'
import { useUserStore } from './user-store'
import { Channel, ChannelData, ChannelImpl } from '../../../shared-src/channel'
import { PaginatedMessagesResponse } from '../../../shared-src/paginated-messages'
import { MessageService } from '../../../shared-src/message-service'

export async function fetchChannels(params: { userId: string }): Promise<void> {
	const { userId } = params

	try {
		const feathersClient = getFeathersClient()
		const channelsService = feathersClient.service('channels')

		const channelDataList = await channelsService.find({
			query: { userId }
		})
		const channels = channelDataList.map((channelData: ChannelData) => new ChannelImpl(channelData, userId))

		const { setChannels, activeChannelId, setActiveChannelId } = useChatStore.getState()
		setChannels(channels)

		const activeChannel = channels.find((ch: Channel) => ch.id === activeChannelId)
		if (!activeChannel && channels.length > 0)
			setActiveChannelId(channels[0].id)
	} catch (error) {
		console.error('Failed to fetch channels:', error)
	}
}

export async function fetchMessages(params: { channelId: string }): Promise<void> {
	const { channelId } = params

	try {
		const feathersClient = getFeathersClient()
		const messagesService = feathersClient.service('messages') as unknown as MessageService
		const { pageSize, setMessagesForChannel } = useChatStore.getState()

		const response: PaginatedMessagesResponse = await messagesService.loadPage({
			channelId,
			maxCount: pageSize
		})
		setMessagesForChannel(channelId, {
			messages: response.messages,
			hasMore: response.hasMore
		})
	} catch (error) {
		console.error('Failed to fetch messages:', error)
	}
}

export async function fetchChannelDetails(params: { channelId: string }): Promise<void> {
	const { channelId } = params

	try {
		const feathersClient = getFeathersClient()
		const channelService = feathersClient.service('channels')

		const channelData = await channelService.get(channelId)
		const userId = useUserStore.getState().user?.userId
		const channel = new ChannelImpl(channelData, userId)

		const { updateChannel } = useChatStore.getState()
		updateChannel(channel)
	} catch (error) {
		console.error('Failed to fetch channel details:', error)
	}
}
